// Il servizio serale copre le 18:00 di un giorno fino alle 3:00 del giorno dopo: quella
// coda notturna (00:00-02:59) appartiene ancora alla serata precedente.
export function businessDateOf(dateStr: string, timeStr: string): string {
  const hour = Number(timeStr.slice(0, 2));
  if (Number.isFinite(hour) && hour < 3) {
    const d = new Date(`${dateStr}T00:00:00`);
    d.setDate(d.getDate() - 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }
  return dateStr;
}

export function currentBusinessDate(): string {
  const now = new Date();
  if (now.getHours() < 3) now.setDate(now.getDate() - 1);
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}
